<mat-label class="title d-block mt-0 mt-md-5 mb-4">{{ 'claimData.title' | translate }}</mat-label>
<mat-stepper orientation="vertical" class="stepper stepper-vertical" #stepper (animationDone)="onStepperUpdate()">
	<form [formGroup]="formGroup">
		<mat-step [completed]="showStepSummary['date']['show'] && !showStepSummary['date']['empty']" [editable]="false">
			<div class="container-link-modify" *ngIf="showStepSummary['date']['show']">
				<span class="link fw-normal fs-6 text-primary" (click)="hideSummary('date')">{{
					'common.modify' | translate
				}}</span>
			</div>
			<ng-template matStepLabel>
				<div class="d-flex align-items-center justify-content-between w-100">
					<span class="title">{{ 'claimData.date.title' | translate }}</span>
				</div>
			</ng-template>
			<ng-template matStepContent>
				<div [hidden]="showStepSummary['date']['show']">
					<div class="row">
						<div class="col">
							<p class="mt-3 mb-2">{{ 'claimData.date.description' | translate }}</p>
						</div>
					</div>
					<div class="row mb-5">
						<div class="col col-md-4">
							<div class="input-group">
								<input
									class="form-control"
									placeholder="yyyy-mm-dd"
									name="dp"
									ngbDatepicker
									#d="ngbDatepicker"
									placement="bottom"
									container="body"
									formControlName="claimDate"
									[maxDate]="todayObject"
								/>
								<button class="btn btn-light btn-calendar d-flex" (click)="d.toggle()" type="button">
									<i class="icon hs-icon-calendar"></i>
								</button>
							</div>
							<validation-messages [control]="formGroup.get('claimDate')"></validation-messages>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<button type="button" class="btn w-100 w-md-initial" 
								[ngClass]="{'btn-light': !formGroup.get('claimDate'),
														'btn-outline-primary': formGroup.get('claimDate')}" 
								(click)="showSummary('date')">
								{{ 'common.confirm' | translate }}
							</button>
						</div>
					</div>
				</div>
				<div class="row" *ngIf="showStepSummary['date']['show'] && !showStepSummary['date']['empty']">
					<div class="col">
						<p *ngIf="dateFormatted" class="mt-3 mb-2">{{ dateFormatted }}</p>
					</div>
				</div>
			</ng-template>
		</mat-step>
		<mat-step
			[completed]="showStepSummary['details']['show'] && !showStepSummary['details']['empty']"
			[editable]="false"
		>
			<div class="container-link-modify" *ngIf="showStepSummary['details']['show']">
				<span class="link fw-normal fs-6 text-primary" (click)="hideSummary('details')">{{
					'common.modify' | translate
				}}</span>
			</div>
			<ng-template matStepLabel>
				<div class="d-flex align-items-center justify-content-between w-100">
					<span class="title">{{ 'claimData.details.title' | translate }}</span>
				</div>
			</ng-template>
			<ng-template matStepContent>
				<div
					id="accordionContainer"
					formGroupName="claimDetails"
					class="row"
					[hidden]="showStepSummary['details']['show']"
				>
					<div class="col-12">
						<p class="mt-3 mb-2">{{ 'claimData.details.selectClaimType' | translate }}</p>
					</div>
					<div
						class="col-12 d-flex align-items-start align-items-md-center justify-content-start justify-content-md-between flex-column flex-md-row mb-2"
					>
						<p class="fw-bold fs-6 m-0">{{ 'claimData.details.claimType' | translate }}</p>
						<button
							*ngIf="isAccordionOpen"
							class="fs-6 text-primary text-decoration-none d-flex"
							style="border: none; background-color: transparent"
							(click)="collapseAccordions(true)"
						>
							<i class="icon hs-icon-chevron-left"></i
							><span class="text-decoration-underline">{{ 'claimData.details.showAllClaims' | translate }}</span>
						</button>
					</div>
					<validation-messages [control]="formGroup.get('claimDetails')?.get('claimCauseGroup')"></validation-messages>
					<div
						class="{{ 'accordion-first-level ' + accordionClass + ' col-md-12 ' + marginClass }}"
						*ngFor="let cause of causeGroups; let i = index"
					>
						<ngb-accordion
							#acc="ngbAccordion"
							[closeOthers]="true"
							[destroyOnHide]="true"
							[ngClass]="{ 'accordion-mobile': !isAccordionOpen }"
						>
							<ngb-panel
								*ngIf="
									!isAccordionOpen ||
									formGroup.get('claimDetails')?.get('claimCauseGroup')?.value?.causeGroupId === cause.causeGroupId
								"
								[id]="cause.causeGroupId"
							>
								<ng-template ngbPanelHeader>
									<i
										class="icon icon-tooltip hs-icon-info"
										container="body"
										placement="top"
										[ngbTooltip]="cause.causeGroupHelp"
										#infoTooltip="ngbTooltip"
										(click)="openTooltip(infoTooltip, cause.causeGroupHelp)"
									>
									</i>
									<button
										ngbPanelToggle
										class="accordion-button"
										[ngClass]="{ 'accordion-button-mobile': !isAccordionOpen }"
										(click)="causeGroupClickHandler(cause)"
									>
										<i [ngClass]="setCauseGroupIcon(cause.causeGroupId)"></i>
										{{ cause.causeGroupName }}
									</button>
								</ng-template>
								<ng-template ngbPanelContent>
									<div class="col col-md-6 m-3">
										<label for="damageType" class="form-label">{{ 'claimData.details.damageType' | translate }}</label>
										<div ngbDropdown id="damageType" class="mb-3">
											<button class="btn btn-light w-100" id="dropdownDamageType" ngbDropdownToggle>
												<p
													class="m-0"
													[ngClass]="{
														'dropdown-toggle-placeholder':
															formGroup.get('claimDetails')?.get('claimDamageType')?.value === ''
													}"
												>
													{{
														formGroup.get('claimDetails')?.get('claimDamageType')?.value !== ''
															? formGroup.get('claimDetails')?.get('claimDamageType')?.value.damageTypeDesc
															: ('common.select' | translate)
													}}
												</p>
											</button>
											<div ngbDropdownMenu aria-labelledby="dropdownDamageType">
												<button
													ngbDropdownItem
													*ngFor="let damageType of damageTypes"
													id="{{ damageType.damageTypeId }}"
													(click)="callDamageDetail(damageType)"
													[ngbTooltip]="damageType.damageTypeHelp"
													placement="auto"
													container="body"
												>
													{{ damageType.damageTypeDesc }}
												</button>
											</div>
											<validation-messages
												[control]="formGroup.get('claimDetails')?.get('claimDamageType')"
											></validation-messages>
										</div>
										<label
											for="damageDetail"
											class="form-label"
											*ngIf="
												formGroup.get('claimDetails')?.get('claimDamageType')?.value &&
												damageDetails.length > 0 &&
												damageDetails[0]?.damageDetailId !== '1'
											"
											>{{ 'claimData.details.damageDetail' | translate }}</label
										>
										<div
											ngbDropdown
											id="damageDetail"
											class="mb-3"
											*ngIf="
												formGroup.get('claimDetails')?.get('claimDamageType')?.value &&
												damageDetails.length > 0 &&
												damageDetails[0]?.damageDetailId !== '1'
											"
										>
											<button class="btn btn-light w-100" id="dropdownDamageDetail" ngbDropdownToggle>
												<p
													class="m-0"
													[ngClass]="{
														'dropdown-toggle-placeholder':
															formGroup.get('claimDetails')?.get('claimDamageDetail')?.value === ''
													}"
												>
													{{
														formGroup.get('claimDetails')?.get('claimDamageDetail')?.value !== ''
															? formGroup.get('claimDetails')?.get('claimDamageDetail')?.value.damageDetailDesc
															: ('common.select' | translate)
													}}
												</p>
											</button>
											<div ngbDropdownMenu aria-labelledby="dropdownDamageDetail">
												<button
													ngbDropdownItem
													*ngFor="let detail of damageDetails"
													id="{{ detail.damageDetailId }}"
													(click)="callDamageCause(detail)"
													[ngbTooltip]="detail.damageDetailHelp"
													placement="auto"
													container="body"
												>
													{{ detail.damageDetailDesc }}
												</button>
											</div>
											<validation-messages
												[control]="formGroup.get('claimDetails')?.get('claimDamageDetail')"
											></validation-messages>
										</div>
										<label
											for="damageCause"
											class="form-label"
											*ngIf="
												formGroup.get('claimDetails')?.get('claimDamageDetail')?.value &&
												damageCauses.length > 0 &&
												damageCauses[0]?.damageCauseId !== '1'
											"
											>{{ 'claimData.details.damageCause' | translate }}</label
										>
										<div
											ngbDropdown
											id="damageCause"
											class="mb-3"
											*ngIf="
												formGroup.get('claimDetails')?.get('claimDamageDetail')?.value &&
												damageCauses.length > 0 &&
												damageCauses[0]?.damageCauseId !== '1'
											"
										>
											<button class="btn btn-light w-100" id="dropdownDamageCause" ngbDropdownToggle>
												<p
													class="m-0"
													[ngClass]="{
														'dropdown-toggle-placeholder':
															formGroup.get('claimDetails')?.get('claimCause')?.value === ''
													}"
												>
													{{
														formGroup.get('claimDetails')?.get('claimCause')?.value !== ''
															? formGroup.get('claimDetails')?.get('claimCause')?.value.damageCauseDesc
															: ('common.select' | translate)
													}}
												</p>
											</button>
											<div ngbDropdownMenu aria-labelledby="dropdownDamageCause">
												<button
													ngbDropdownItem
													*ngFor="let cause of damageCauses"
													id="{{ cause.damageCauseId }}"
													(click)="callThirdDamage(cause)"
												>
													{{ cause.damageCauseDesc }}
												</button>
											</div>
											<validation-messages
												[control]="formGroup.get('claimDetails')?.get('claimCause')"
											></validation-messages>
										</div>
									</div>
								</ng-template>
							</ngb-panel>
						</ngb-accordion>
					</div>
					<div
						class="col-12 mb-4"
						*ngIf="
							damageDetailIdWithDevices?.includes(
								formGroup.get('claimDetails')?.get('claimDamageDetail')?.value.damageDetailId
							) ||
							damageTypeIdWithDevices?.includes(
								formGroup.get('claimDetails')?.get('claimDamageType')?.value.damageTypeId
							)
						"
					>
						<p>{{ 'claimData.details.damagedDevice' | translate }}</p>

						<div formArrayName="damagedDevices">
							<div class="row" *ngFor="let damagedDevice of damagedDevices.controls; let i = index">
								<div ngbDropdown class="col-12 col-md-4 ps-0 mb-3">
									<button type="button" class="btn btn-light w-100" id="dropdownBasic1" ngbDropdownToggle>
										{{
											damagedDevice?.get('device')?.value
												? damagedDevice?.get('device')?.value.description
												: ('common.device' | translate)
										}}
									</button>
									<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
										<button
											ngbDropdownItem
											*ngFor="let device of devices"
											(click)="onSelectDevice(damagedDevice, device)"
										>
											{{ device.description }}
										</button>
									</div>
									<validation-messages [control]="damagedDevice.get('device')"></validation-messages>
								</div>
								<div ngbDropdown class="col-10 col-md-4 ps-0 mb-3">
									<button
										type="button"
										class="btn btn-light w-100"
										id="dropdownBasic1"
										ngbDropdownToggle
										[disabled]="!damagedDevice?.get('device')?.value"
									>
										{{
											damagedDevice?.get('brand')?.value ? 
											damagedDevice?.get('brand')?.value.code === 'MR043' ? ('common.others' | translate) :
											damagedDevice?.get('brand')?.value.description
												: ('common.brand' | translate)
										}}
									</button>
									<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
										<button
											ngbDropdownItem
											*ngFor="let brand of damagedDevice?.get('device')?.value?.brands"
											(click)="onSelectBrand(damagedDevice, brand)"
										>
											{{ brand.description }}
										</button>
									</div>
									<validation-messages [control]="damagedDevice.get('brand')"></validation-messages>
								</div>
								<div class="col-2 col-md-4 mb-3 mb-md-0">
									<button type="button" class="btn d-flex text-primary" (click)="removeDamagedDevice(i)">
										<i
											class="icon hs-icon-minus rounded-circle border border-primary me-2 fs-6 fw-bold text-danger border-danger"
										></i>
									</button>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-md-4 mb-3 mb-md-0 d-flex justify-content-center justify-content-md-end pe-0">
									<button type="button" class="btn d-flex text-primary" (click)="newDamagedDevice()">
										<i class="icon hs-icon-plus rounded-circle border border-primary me-2 fs-6 fw-bold"></i>
										{{ 'claimData.details.addDevice' | translate }}
									</button>
								</div>
							</div>
						</div>
					</div>

					<div
						class="row mt-4"
						*ngIf="formGroup.get('claimDetails')?.get('claimCauseGroup')?.valid && causeBelongToGroup()"
					>
						<div class="col-12 ps-0">
							<p class="fw-bold mb-2">{{ 'claimData.details.insuredHomeCause.question' | translate }}</p>
							<div class="form-check">
								<input
									class="form-check-input"
									type="radio"
									name="insuredHome"
									id="insuredHomeYes"
									[value]="true"
									formControlName="insuredHome"
									(click)="onChangeInsuredHome('true')"
								/>
								<label class="form-check-label ms-2 mt-1" for="insuredHomeYes">
									{{ 'claimData.details.insuredHomeCause.yes' | translate }}
								</label>
							</div>
							<div class="form-check mt-2">
								<input
									class="form-check-input"
									type="radio"
									name="insuredHome"
									id="insuredHomeNo"
									[value]="false"
									formControlName="insuredHome"
									(click)="onChangeInsuredHome('false')"
								/>
								<label class="form-check-label ms-2 mt-1" for="insuredHomeNo">
									{{ 'claimData.details.insuredHomeCause.no' | translate }}
								</label>
							</div>
							<div class="form-check mt-3">
								<input
									class="form-check-input"
									type="radio"
									name="insuredHome"
									id="insuredHomeUnknown"
									[value]="1"
									formControlName="insuredHome"
									(click)="onChangeInsuredHome('true')"
								/>
								<label class="form-check-label ms-2 mt-1" for="insuredHomeYes">
									{{ 'claimData.details.insuredHomeCause.unknown' | translate }}
								</label>
							</div>
							<validation-messages [control]="formGroup.get('claimDetails')?.get('insuredHome')"></validation-messages>
						</div>
						<div class="col-12 ps-0 mt-4" *ngIf="formGroup.get('claimDetails')?.get('insuredHome')?.value == false ">
							<p class="fw-bold mb-2">{{ 'originFix.question' | translate }}</p>
							<div class="form-check">
								<input
									class="form-check-input"
									type="radio"
									name="originFix"
									id="originFixYes"
									[value]="true"
									formControlName="originFix"
								/>
								<label class="form-check-label ms-2 mt-1" for="originFixYes">
									{{ 'originFix.causerfix' | translate }}
								</label>
							</div>
							<div class="form-check mt-2">
								<input
									class="form-check-input"
									type="radio"
									name="originFix"
									id="originFixNo"
									[value]="false"
									formControlName="originFix"
								/>
								<label class="form-check-label ms-2 mt-1" for="originFixNo">
									{{ 'originFix.causernotfix' | translate }}
								</label>
							</div>
							<div class="form-check mt-3">
								<input
									class="form-check-input"
									type="radio"
									name="originFix"
									id="originFixUnknown"
									[value]="1"
									formControlName="originFix"
								/>
								<label class="form-check-label ms-2 mt-1" for="originFixUnknown">
									{{ 'originFix.causerfixunknown' | translate }}
								</label>
							</div>
							<validation-messages [control]="formGroup.get('claimDetails')?.get('originFix')"></validation-messages>
						</div>	
					</div>
					<div class="col-12 mt-4">
						<button type="button" (click)="showSummary('details')" class="btn w-100 w-md-initial"
							[ngClass]="{'btn-light': !formGroup.get('claimDetails')?.valid || (formGroup.get('claimDetails')?.get('insuredHome')?.value == false && !formGroup.get('claimDetails')?.get('originFix')?.value)   ,
													'btn-outline-primary': formGroup.get('claimDetails')?.valid}" >
							{{ 'common.confirm' | translate }}
						</button>
					</div>
				</div>
				<div class="row" *ngIf="showStepSummary['details']['show'] && !showStepSummary['details']['empty']">
					<div class="col">
						<p *ngIf="damagedFormatted">{{ 'claimData.details.damageSummary' | translate }} {{ damagedFormatted }}</p>
					</div>
				</div>
			</ng-template>
		</mat-step>
		<mat-step [completed]="showStepSummary['cause']['show'] && !showStepSummary['cause']['empty']" [editable]="false">
			<div class="container-link-modify" *ngIf="showStepSummary['cause']['show']">
				<span class="link fw-normal fs-6 text-primary" (click)="hideSummary('cause')">{{
					'common.modify' | translate
				}}</span>
			</div>
			<ng-template matStepLabel>
				<div class="d-flex align-items-center justify-content-between w-100">
					<span class="title">{{ 'claimData.causes.title' | translate }}</span>
				</div>
			</ng-template>
			<ng-template matStepContent>
				<div class="row" [hidden]="showStepSummary['cause']['show']">
					<div class="col-12" formGroupName="causerData">
						<p class="mt-4" *ngIf="!this.formGroup.get('claimDetails')?.get('insuredHome')?.value">
							{{ 'claimData.causes.causerData.title' | translate }}
						</p>
						<div class="col col-md-6 mb-3" *ngIf="!this.formGroup.get('claimDetails')?.get('insuredHome')?.value">
							<label for="causerRelationshipDropdown" class="form-label">{{ 'common.relationship' | translate }}</label>
							<div ngbDropdown>
								<button type="button" class="btn btn-light w-100" id="causerRelationshipDropdown" ngbDropdownToggle>
									<p
										class="m-0"
										[ngClass]="{
											'dropdown-toggle-placeholder':
												formGroup.get('causerData')?.get('causerRelationShip')?.value === ''
										}"
									>
										{{
											formGroup.get('causerData')?.get('causerRelationShip')?.value
												? formGroup.get('causerData')?.get('causerRelationShip')?.value.description
												: ('common.relationship' | translate)
										}}
									</p>
								</button>
								<div ngbDropdownMenu aria-labelledby="causerRelationshipDropdown">
									<button
										ngbDropdownItem
										*ngFor="let relationship of declarantRelationships"
										(click)="setInsuredRelationship('causer', relationship)"
									>
										{{ relationship.description }}
									</button>
								</div>
								<validation-messages
									[control]="formGroup.get('causerData')?.get('causerRelationShip')"
								></validation-messages>
							</div>
						</div>
						<div class="col col-md-6 mb-3" *ngIf="!this.formGroup.get('claimDetails')?.get('insuredHome')?.value">
							<div class="d-flex align-items-center justify-content-between">
								<label for="causerNameInput" class="form-label">{{ 'common.name' | translate }}</label>
								<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
							</div>
							<input
								type="text"
								class="form-control"
								id="causerNameInput"
								placeholder="{{ 'common.name' | translate }}"
								formControlName="causerName"
								maxlength="20"
							/>
							<validation-messages [control]="formGroup.get('causerData')?.get('causerName')"></validation-messages>
						</div>
						<div class="col col-md-6 mb-3" *ngIf="!this.formGroup.get('claimDetails')?.get('insuredHome')?.value">
							<div class="d-flex align-items-center justify-content-between">
								<label for="causerSurname1Input" class="form-label">{{ 'common.surname1' | translate }}</label>
								<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
							</div>
							<input
								type="text"
								class="form-control"
								id="causerSurname1Input"
								placeholder="{{ 'common.surname1' | translate }}"
								formControlName="causerSurname1"
								maxlength="20"
							/>
							<validation-messages [control]="formGroup.get('causerData')?.get('causerSurname1')"></validation-messages>
						</div>
						<div class="col col-md-6 mb-3" *ngIf="!this.formGroup.get('claimDetails')?.get('insuredHome')?.value">
							<div class="d-flex align-items-center justify-content-between">
								<label for="causerSurname2Input" class="form-label">{{ 'common.surname2' | translate }}</label>
								<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
							</div>
							<input
								type="text"
								class="form-control"
								id="causerSurname2Input"
								placeholder="{{ 'common.surname2' | translate }}"
								formControlName="causerSurname2"
								maxlength="20"
							/>
							<validation-messages [control]="formGroup.get('causerData')?.get('causerSurname2')"></validation-messages>
						</div>
						<div class="col col-md-6 mb-3" *ngIf="!this.formGroup.get('claimDetails')?.get('insuredHome')?.value">
							<div class="d-flex align-items-center justify-content-between">
								<label for="causerEmailInput" class="form-label">{{ 'common.email' | translate }}</label>
								<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
							</div>
							<input
								type="email"
								class="form-control"
								id="causerEmailInput"
								placeholder="{{ 'common.email' | translate }}"
								formControlName="causerEmail"
								maxlength="90"
							/>
							<validation-messages [control]="formGroup.get('causerData')?.get('causerEmail')"></validation-messages>
						</div>
						<div class="col col-md-6 mb-3" *ngIf="!this.formGroup.get('claimDetails')?.get('insuredHome')?.value">
							<div class="d-flex align-items-center justify-content-between">
								<label for="causerPhoneInput" class="form-label">{{ 'common.phone' | translate }}</label>
								<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
							</div>
							<div class="input-group mb-3">
								<div ngbDropdown>
									<button
										type="button"
										class="btn btn-light rounded-0 rounded-start w-100"
										id="dropdownCauserPhonePrefix"
										ngbDropdownToggle
									>
										{{ formGroup.get('causerData')?.get('causerPrefixPhone')?.value }}
									</button>
									<div ngbDropdownMenu aria-labelledby="dropdownCauserPhonePrefix">
										<button
											ngbDropdownItem
											*ngFor="let prefix of prefixList"
											(click)="onSelectPrefix('causerData', prefix)"
										>
											{{ prefix }}
										</button>
									</div>
								</div>
								<input
									*ngIf="formGroup.get('causerData')?.get('causerPrefixPhone')?.value === '+34'"
									type="text"
									class="form-control"
									id="causerPhoneInput"
									placeholder="{{ 'common.phone' | translate }}"
									formControlName="causerPhone"
									maxlength="9"
									minlength="9"
									onlyNumber
								/>
								<input
									*ngIf="formGroup.get('causerData')?.get('causerPrefixPhone')?.value !== '+34'"
									type="text"
									class="form-control"
									id="causerPhoneInput"
									placeholder="{{ 'common.phone' | translate }}"
									formControlName="causerPhone"
								/>
								<validation-messages [control]="formGroup.get('causerData')?.get('causerPhone')"></validation-messages>
							</div>
						</div>
						<div *ngIf="ownDamages.length > 0">
							<div class="col col-md-6 mb-3">
								<p class="fw-medium mb-2">
									{{ 'claimData.causes.causerData.insuredHomeDamage.title' | translate }}
								</p>
								<div class="form-check">
									<input
										class="form-check-input"
										type="radio"
										name="radioHomeDamage"
										id="radioHomeDamageYes"
										[value]="true"
										formControlName="radioHomeDamage"
									/>
									<label class="form-check-label ms-2 mt-1" for="radioHomeDamageYes">
										{{ 'common.yes' | translate }}
									</label>
								</div>
								<div class="form-check mt-2">
									<input
										class="form-check-input"
										type="radio"
										name="radioHomeDamage"
										id="radioHomeDamageNo"
										[value]="false"
										formControlName="radioHomeDamage"
										(change)="clearOwnOtherDamages($event)"
									/>
									<label class="form-check-label ms-2 mt-1" for="radioHomeDamageNo">
										{{ 'common.no' | translate }}
									</label>
								</div>
							</div>
							<div *ngIf="formGroup.get('causerData')?.get('radioHomeDamage')?.value" class="col col-md-6 mb-3">
								<p class="ffw-bold mb-2">
									{{ 'claimData.causes.causerData.insuredHomeDamage.damages' | translate }}
								</p>
								<div
									class="form-check form-check-mobile"
									[ngClass]="{ active: checkActive }"
									*ngFor="let ownDamage of ownDamages"
								>
									<div class="col">
										<input
											class="form-check-input"
											type="checkbox"
											[name]="ownDamage.ownDamage"
											[checked]="ownDamagesChecked[ownDamage.id]"
											(change)="setOwnDamageArray($event, ownDamage)"
										/>
										<label class="form-check-label ms-2 mt-1"
													 [for]="ownDamage.ownDamage"
													 [attr.title]="(ownDamage.ownDamage === 'Otros daños de elementos fijos') ?
                							('claimData.causes.causerData.insuredHomeDamage.titleOtherDamages' | translate) : '' "
										>  		 {{ ownDamage.ownDamage }}
										</label>
									</div>
								</div>
								<div class="row" *ngIf="otherDamages.length > 0">
									<div
										class="form-check form-check-mobile"
										[ngClass]="{ active: checkActive }"
										*ngFor="let otherDamage of otherDamages"
									>
										<div class="col">
											<input
												class="form-check-input"
												type="checkbox"
												[name]="otherDamage.otherDamage"
												[checked]="otherDamagesChecked[otherDamage.otherDamage]"
												(change)="setOtherDamageArray($event, otherDamage)"
											/>
											<label class="form-check-label ms-2 mt-1" [for]="otherDamage.otherDamage">{{
												otherDamage.otherDamage
											}}</label>
										</div>
									</div>
								</div>
								<span *ngIf="requiredOwnDamages" class="text-danger">
									{{'claimData.causes.causerData.insuredHomeDamage.ownDamagesRequired' | translate }}
								</span>
							</div>
						</div>
					</div>
					<div
						class="col-12"
						formGroupName="thirdDamagedData"
						*ngIf="thirdDamages.length > 0 && this.formGroup.get('claimDetails')?.get('insuredHome')?.value"
					>
						<p class="fw-bold mb-2">{{ 'claimData.causes.thirdDamagedData.question' | translate }}</p>
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="radioThirdDamage"
								id="radioThirdDamageYes"
								[value]="true"
								formControlName="radioThirdDamage"
							/>
							<label class="form-check-label ms-2 mt-1" for="radioThirdDamageYes">
								{{ 'common.yes' | translate }}
							</label>
						</div>
						<div class="form-check mt-2">
							<input
								class="form-check-input"
								type="radio"
								name="radioThirdDamage"
								id="radioThirdDamageNo"
								[value]="false"
								formControlName="radioThirdDamage"
								(change)="clearThirdDamages($event)"
							/>
							<label class="form-check-label ms-2 mt-1" for="radioThirdDamageNo"> {{ 'common.no' | translate }} </label>
						</div>
						<div *ngIf="formGroup.get('thirdDamagedData')?.get('radioThirdDamage')?.value">
							<div class="col col-md-6 mb-3">
								<p class="mt-4">{{ 'claimData.causes.thirdDamagedData.title' | translate }}</p>
								<label for="thirdDamagesDropdown" class="form-label">{{ 'common.relationship' | translate }}</label>
								<div ngbDropdown>
									<button type="button" class="btn btn-light w-100" id="thirdDamagesDropdown" ngbDropdownToggle>
										<p
											class="m-0"
											[ngClass]="{
												'dropdown-toggle-placeholder':
													formGroup.get('thirdDamagedData')?.get('thirdDamagedRelationShip')?.value === ''
											}"
										>
											{{
												formGroup.get('thirdDamagedData')?.get('thirdDamagedRelationShip')?.value !== ''
													? formGroup.get('thirdDamagedData')?.get('thirdDamagedRelationShip')?.value.description
													: ('common.relationship' | translate)
											}}
										</p>
									</button>
									<div ngbDropdownMenu aria-labelledby="thirdDamagesDropdown">
										<button
											ngbDropdownItem
											*ngFor="let relationship of declarantRelationships"
											(click)="setInsuredRelationship('damaged', relationship)"
										>
											{{ relationship.description }}
										</button>
									</div>
								</div>
								<validation-messages
									[control]="formGroup.get('thirdDamagedData')?.get('thirdDamagedRelationShip')"
								></validation-messages>
							</div>
							<div class="col col-md-6 mb-3">
								<div class="d-flex align-items-center justify-content-between">
									<label for="damagedNameInput" class="form-label">{{ 'common.name' | translate }}</label>
									<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
								</div>
								<input
									type="text"
									class="form-control"
									id="damagedNameInput"
									placeholder="{{ 'common.name' | translate }}"
									formControlName="thirdDamagedName"
									maxlength="20"
								/>
								<validation-messages
									[control]="formGroup.get('thirdDamagedData')?.get('thirdDamagedName')"
								></validation-messages>
							</div>
							<div class="col col-md-6 mb-3">
								<div class="d-flex align-items-center justify-content-between">
									<label for="damageSurname1Input" class="form-label">{{ 'common.surname1' | translate }}</label>
									<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
								</div>
								<input
									type="text"
									class="form-control"
									id="damageSurname1Input"
									placeholder="{{ 'common.surname1' | translate }}"
									formControlName="thirdDamagedSurname1"
									maxlength="20"
								/>
								<validation-messages
									[control]="formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname1')"
								></validation-messages>
							</div>
							<div class="col col-md-6 mb-3">
								<div class="d-flex align-items-center justify-content-between">
									<label for="damageSurname2Input" class="form-label">{{ 'common.surname2' | translate }}</label>
									<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
								</div>
								<input
									type="text"
									class="form-control"
									id="damageSurname2Input"
									placeholder="{{ 'common.surname2' | translate }}"
									formControlName="thirdDamagedSurname2"
									maxlength="20"
								/>
								<validation-messages
									[control]="formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname2')"
								></validation-messages>
							</div>
							<div class="col col-md-6 mb-3">
								<div class="d-flex align-items-center justify-content-between">
									<label for="damageEmailInput" class="form-label">{{ 'common.email' | translate }}</label>
									<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
								</div>
								<input
									type="text"
									class="form-control"
									id="damageEmailInput"
									placeholder="{{ 'common.email' | translate }}"
									formControlName="thirdDamagedEmail"
									maxlength="90"
								/>
								<validation-messages
									[control]="formGroup.get('thirdDamagedData')?.get('thirdDamagedEmail')"
								></validation-messages>
							</div>
							<div class="col col-md-6 mb-3">
								<div class="d-flex align-items-center justify-content-between">
									<label for="damagePhoneInput" class="form-label">{{ 'common.phone' | translate }}</label>
									<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
								</div>
								<div class="input-group mb-3">
									<div ngbDropdown>
										<button
											type="button"
											class="btn btn-light rounded-0 rounded-start w-100"
											id="dropdownDmgPhonePrefix"
											ngbDropdownToggle
										>
											{{ formGroup.get('thirdDamagedData')?.get('thirdDamagedPrefixPhone')?.value }}
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownDmgPhonePrefix">
											<button
												ngbDropdownItem
												*ngFor="let prefix of prefixList"
												(click)="onSelectPrefix('thirdDamagedData', prefix)"
											>
												{{ prefix }}
											</button>
										</div>
									</div>
									<input
										*ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedPrefixPhone')?.value === '+34'"
										type="text"
										class="form-control"
										id="damagePhoneInput"
										placeholder="{{ 'common.phone' | translate }}"
										formControlName="thirdDamagedPhone"
										maxlength="9"
										minlength="9"
										onlyNumber
									/>
									<input
										*ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedPrefixPhone')?.value !== '+34'"
										type="text"
										class="form-control"
										id="damagePhoneInput"
										placeholder="{{ 'common.phone' | translate }}"
										formControlName="thirdDamagedPhone"
									/>
									<validation-messages
										[control]="formGroup.get('thirdDamagedData')?.get('thirdDamagedPhone')"
									></validation-messages>
								</div>
							</div>
							<div class="col col-md-6 mb-3">
								<div class="d-flex align-items-center justify-content-between">
									<label for="damageAddressInput" class="form-label">{{ 'common.address' | translate }}</label>
									<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
								</div>
								<input
									type="text"
									class="form-control"
									id="damageAddressInput"
									placeholder="{{ 'common.address' | translate }}"
									formControlName="thirdDamagedAddress"
									maxlength="80"
								/>
								<validation-messages
									[control]="formGroup.get('thirdDamagedData')?.get('thirdDamagedAddress')"
								></validation-messages>
							</div>
							<div *ngIf="thirdDamages.length > 0">
								<div class="col col-md-6 mb-3">
									<p class="ffw-bold mb-2">
										{{ 'claimData.causes.thirdDamagedData.personDamages.damages' | translate }}
									</p>
									<div
										class="form-check form-check-mobile"
										[ngClass]="{ active: checkActive }"
										*ngFor="let thirdHarm of thirdDamages"
									>
										<div class="col">
											<input
												class="form-check-input"
												type="checkbox"
												[name]="thirdHarm.thirdHarm"
												[checked]="thirdOwnDmgsChecked[thirdHarm.thirdHarm]"
												(change)="setThirdOwnDamageArray($event, thirdHarm)"
											/>
											<label class="form-check-label ms-2 mt-1" [for]="thirdHarm.thirdHarm">{{
												thirdHarm.thirdHarm
											}}</label>
										</div>
									</div>
									<div class="row" *ngIf="otherThirdDamages.length > 0">
										<div
											class="form-check form-check-mobile"
											[ngClass]="{ active: checkActive }"
											*ngFor="let otherthirdHarm of otherThirdDamages"
										>
											<div class="col">
												<input
													class="form-check-input"
													type="checkbox"
													[name]="otherthirdHarm.otherthirdHarm"
													[checked]="thirdOtherDmgsChecked[otherthirdHarm.otherthirdHarm]"
													(change)="setThirdOtherDamageArray($event, otherthirdHarm)"
												/>
												<label class="form-check-label ms-2 mt-1" [for]="otherthirdHarm.otherthirdHarm">{{
													otherthirdHarm.otherthirdHarm
												}}</label>
											</div>
										</div>
									</div>
									<span *ngIf="requiredThirdDamages" class="text-danger">
										{{'claimData.causes.thirdDamagedData.personDamages.thirdDamagesRequired' | translate }}
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-4">
						<p class="mb-2">{{ 'claimData.details.briefDescTitle' | translate }}</p>
						<textarea
							class="form-control mt-4"
							placeholder="{{ 'claimData.details.briefDescPlaceholder' | translate }}"
							formControlName="claimDescription"
							maxlength="{{ maxTextAreaChars }}"
							(ngModelChange)="updateRemainingChars($event)"
							style="max-height: 200px"
						></textarea>
						<span class="float-right" style="margin-right: 10%; color: grey; font-size: smaller"
							>{{ remainingCommentChars }} {{ 'common.remainingChars' | translate }} {{ maxTextAreaChars }}</span
						>
						<div>
							<validation-messages [control]="formGroup.get('claimDescription')"></validation-messages>
						</div>
					</div>
					<div class="mt-4">
						<button type="button" class="btn btn-light w-100 w-md-initial" (click)="showSummary('cause')"
							[ngClass]="{'btn-light': !formGroup.get('claimDescription')?.valid,
													'btn-outline-primary': formGroup.get('claimDescription')?.valid}" >
							{{ 'common.confirm' | translate }}
						</button>
					</div>
				</div>
				<div class="row" *ngIf="showStepSummary['cause']['show'] && !showStepSummary['cause']['empty']">
					<div class="col-12">
						<p class="fw-medium m-0 mt-3 mb-2" *ngIf="formGroup.get('causerData')?.get('causerRelationShip')?.value">
							{{ 'claimData.causes.causerData.title' | translate }}
						</p>
						<p class="m-0 mb-2" *ngIf="formGroup.get('causerData')?.get('causerRelationShip')?.value">
							{{ formGroup.get('causerData')?.get('causerRelationShip')?.value.description }}
						</p>
						<p class="m-0 mb-2">
							<span *ngIf="formGroup.get('causerData')?.get('causerName')?.value">{{
								formGroup.get('causerData')?.get('causerName')?.value
							}}</span>
							{{ ' ' }}
							<span *ngIf="formGroup.get('causerData')?.get('causerSurname1')?.value">{{
								formGroup.get('causerData')?.get('causerSurname1')?.value
							}}</span>
							{{ ' ' }}
							<span *ngIf="formGroup.get('causerData')?.get('causerSurname2')?.value">{{
								formGroup.get('causerData')?.get('causerSurname2')?.value
							}}</span>
						</p>
						<p class="m-0 mb-2" *ngIf="formGroup.get('causerData')?.get('causerEmail')?.value">
							{{ formGroup.get('causerData')?.get('causerEmail')?.value }}
						</p>
						<p class="m-0 mb-2" *ngIf="formGroup.get('causerData')?.get('causerPhone')?.value">
							{{ formGroup.get('causerData')?.get('causerPhone')?.value }}
						</p>
						<p class="m-0" *ngIf="formGroup.get('causerData')?.get('causerInsuranceCompany')?.value">
							{{ formGroup.get('causerData')?.get('causerInsuranceCompany')?.value }}
						</p>
						<p
							class="fw-medium m-0 mt-3 mb-2"
							*ngIf="formGroup.get('causerData')?.get('claimOwnDamages')?.value.length > 0"
						>
							{{ 'claimData.causes.causerData.insuredHomeDamage.damagesSummary' | translate }}
						</p>
						<div *ngFor="let ownDamage of formGroup.get('causerData')?.get('claimOwnDamages')?.value">
							<p class="m-0">{{ ownDamage.ownDamage.ownDamage }}</p>
						</div>
						<div *ngFor="let otherDamage of formGroup.get('causerData')?.get('claimOtherDamages')?.value">
							<p class="m-0">{{ otherDamage.otherDamage.otherDamage }}</p>
						</div>
						<p
							class="fw-medium m-0 mt-3 mb-2"
							*ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedRelationShip')?.value"
						>
							{{ 'claimData.causes.thirdDamagedData.title' | translate }}
						</p>
						<p class="m-0 mb-2" *ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedRelationShip')?.value">
							{{ formGroup.get('thirdDamagedData')?.get('thirdDamagedRelationShip')?.value.description }}
						</p>
						<p class="m-0 mb-2">
							<span *ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedName')?.value">{{
								formGroup.get('thirdDamagedData')?.get('thirdDamagedName')?.value
							}}</span>
							{{ ' ' }}
							<span *ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname1')?.value">{{
								formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname1')?.value
							}}</span>
							{{ ' ' }}
							<span *ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname2')?.value">{{
								formGroup.get('thirdDamagedData')?.get('thirdDamagedSurname2')?.value
							}}</span>
						</p>
						<p class="m-0 mb-2" *ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedEmail')?.value">
							{{ formGroup.get('thirdDamagedData')?.get('thirdDamagedEmail')?.value }}
						</p>
						<p class="m-0 mb-2" *ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedPhone')?.value">
							{{ formGroup.get('thirdDamagedData')?.get('thirdDamagedPhone')?.value }}
						</p>
						<p class="m-0" *ngIf="formGroup.get('thirdDamagedData')?.get('thirdDamagedInsuranceCompany')?.value">
							{{ formGroup.get('thirdDamagedData')?.get('thirdDamagedInsuranceCompany')?.value }}
						</p>
						<p
							class="fw-medium m-0 mt-3 mb-2"
							*ngIf="formGroup.get('thirdDamagedData')?.get('thirdOwnDamages')?.value.length > 0"
						>
							{{ 'claimData.causes.thirdDamagedData.personDamages.damagesSummary' | translate }}
						</p>
						<div *ngFor="let thirdOwnDmg of formGroup.get('thirdDamagedData')?.get('thirdOwnDamages')?.value">
							<p class="m-0">{{ thirdOwnDmg.thirdHarm.thirdHarm }}</p>
						</div>
						<div *ngFor="let thirdOtherDmg of formGroup.get('thirdDamagedData')?.get('thirdOtherDamages')?.value">
							<p class="m-0">{{ thirdOtherDmg.otherthirdHarm.otherThirdHarm }}</p>
						</div>
						<p class="fw-medium m-0 mt-3 mb-2" *ngIf="formGroup.get('claimDescription')?.value">
							{{ 'claimData.causes.causerData.briefDescSummary' | translate }}
						</p>
						<p class="m-0" *ngIf="formGroup.get('claimDescription')?.value" style="white-space: pre">
							{{ formGroup.get('claimDescription')?.value }}
						</p>
					</div>
				</div>
			</ng-template>
		</mat-step>
		<mat-step [editable]="false">
			<ng-template matStepLabel> </ng-template>
			<ng-template matStepContent></ng-template>
		</mat-step>
	</form>
</mat-stepper>
<div class="c-disclamer disclaimer-datos-siniestro" *ngIf="!(formGroup.invalid ||
!showStepSummary['date']['show'] ||
!showStepSummary['details']['show'] ||
!showStepSummary['cause']['show'])">
	<p>
		<span class="title-disclaimer">{{ 'claimConfirm.disclaimer.title' | translate }} </span>
		{{ 'claimConfirm.disclaimer.text' | translate }}
		<a href="{{ 'footer.dataProtectionWeb' | translate }}" target="_blank">{{ 'footer.dataProtectionWeb' | translate }}</a>
	</p>
	<div class="form-check">
		<input
			class="form-check-input"
			type="checkbox"
			name="checkRead"
			id="checkRead"
			(change)="acceptTerms(1)"
		/>
		<label class="form-check-label ms-2 mt-1" for="checkRead">
			{{ 'claimConfirm.disclaimer.read' | translate }}
		</label>
	</div>
	<div class="form-check" *ngIf="this.existDatosTercero()">
		<input
			class="form-check-input"
			type="checkbox"
			name="checkUnderstand"
			id="checkUnderstand"
			(change)="acceptTerms(2)"
		/>
		<label class="form-check-label ms-2 mt-1" for="checkUnderstand">
			{{ 'claimConfirm.disclaimer.understand' | translate }}
		</label>
	</div>
</div>

<div class="row mb-4">
	<div class="col-12 p-0 pt-4 mt-4 border-top d-flex justify-content-between">
		<button
			type="button"
			class="btn btn-outline-primary d-flex align-items-center justify-content-center w-100 w-md-initial"
			matStepperPrevious
		>
			{{ 'claimData.return' | translate }}
		</button>
		<button
			[disabled]="
				formGroup.invalid ||
				!showStepSummary['date']['show'] ||
				!showStepSummary['details']['show'] ||
				!showStepSummary['cause']['show'] ||
				!readTerm || 
				(!understandTerm && this.existDatosTercero())
			"
			(click)="onSubmit()"
			class="btn btn-primary d-flex align-items-center justify-content-center w-100 w-md-initial"
		>
			<i class="icon hs-icon-check text-white"></i>
			{{ 'claimData.send' | translate }}
		</button>
	</div>
</div>
